module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Connection completed. You can close this window.":"Verbindung abgeschlossen. Du kannst dieses Fenster schließen."}}')
  delete Component.options._Ctor
}
